<template>
    <div class="user-stats">
        <div class="user-stats-header">
            <div class="username display-1" v-if="!loading">
                <Avatar :userHash="userHash" class="user-avatar body-2" />
                <div>{{ name }}</div>
            </div>
        </div>
        <LoadingOwl v-if="loading" />

        <v-container v-if="!loading" class="user-stats-content">
            <div class="stat">
                <span class="stat-desc">Level {{ level }}:</span>
                <span class="stat-val">{{ levelName }}</span>
            </div>
            <div class="stat">
                <span class="stat-desc">Total Points:</span>
                <span class="stat-val">{{ totalPoints }} points</span>
            </div>
            <div class="stat">
                <span class="stat-desc">Last 7 Days Points:</span>
                <span class="stat-val">{{ last7DaysPoints }} points</span>
            </div>
            <div class="stat">
                <span class="stat-desc">Last 7 Days Place:</span>
                <span class="stat-val"
                    >{{ last7DaysPlace }} / {{ last7DaysNumPlayers }}</span
                >
            </div>
            <div class="stat">
                <span class="stat-desc">Puzzles Completed:</span>
                <span class="stat-val">{{ numPuzzles }} puzzles</span>
            </div>
            <!--<div class="stat">
                <span class="stat-desc">Power Puzzles Completed:</span>
                <span class="stat-val">12</span>
            </div>-->
            <div class="stat">
                <span class="stat-desc">Member Since:</span>
                <span class="stat-val">{{ memberSince }}</span>
            </div>
            <!--<div class="stat">
                <span class="stat-desc">Puzzle League Member:</span>
                <span class="stat-val">UNKNOWN</span>
            </div>-->
        </v-container>
    </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import moment from "moment";
import Avatar from "@/components/Avatar.vue";
import LevelManager from "@/LevelManager";
import LoadingOwl from "@/components/LoadingOwl.vue";

export default {
    name: "UserStats",
    props: ["userHash", "authenticated"],
    components: { Avatar, LoadingOwl },
    data: () => {
        return {
            name: "",
            level: "",
            numPuzzles: "",
            memberSince: "",
            puzzleLeagueMember: false,
            last7DaysPlace: "",
            last7DaysNumPlayers: "",
            last7DaysPoints: "",
            totalPoints: "",
            loading: false,
        };
    },
    mounted() {
        this.getUserStats(this.userHash);
    },
    computed: {
        levelName() {
            if (this.level) {
                return `Puzzle ${LevelManager.getRankName(this.level)}`;
            }
            return "";
        },
    },
    methods: {
        getUserStats(userHash) {
            this.loading = true;
            axios
                .get(
                    `https://i0tr7oa202.execute-api.us-east-1.amazonaws.com/dev/getuserstats?userHash=${userHash}`
                )
                .then((response) => {
                    let data = response.data;
                    this.name = data.name || "Anonymous";
                    this.level = data.level;
                    this.numPuzzles = data.numPuzzles;
                    this.memberSince = moment(data.createdDate).format(
                        "MMM DD, YYYY"
                    );
                    this.last7DaysPlace = data.place;
                    this.last7DaysNumPlayers = data.numPlayers;
                    this.puzzleLeagueMember = null;
                    this.totalPoints = data.totalPoints;
                    this.last7DaysPoints = data.pointsLast7Days;
                    this.loading = false;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.user-stats {
    text-align: center;
    left: 0;
    right: 0;
    padding: 20px 20px 30px 20px;
    width: 90%;
    margin: auto;
    border: 2px solid $pod-teal;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 8px;
}

.stat {
    display: flex;
    justify-content: space-between;
    .stat-desc {
        font-weight: bold;
    }
    .stat-val {
    }
}

.user-stats-header {
    text-align: center;
    margin-bottom: 20px;
}
.username {
    margin-top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.user-avatar {
    margin-right: 10px;
    width: 50px;
    height: 50px;
}
</style>
